import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
const SecurityContext = createContext({ access: {} });
const SecurityContextProvider = SecurityContext.Provider;
export { SecurityContext };
/**
 * NerdSecurityAgentWrapper
 *
 * @param {NerdSecurityAgentWrapperProps} props component props
 * @returns {null} NerdSecurityAgentWrapper
 */
export function NerdSecurityAgentWrapper(props) {
    const queryString = window.location.search;
    const highlightFromUrl = new URLSearchParams(queryString).get("hightlightSecurityGates");
    const { overwrite, children, access } = props;
    const highlight = highlightFromUrl === "true"
        ? true
        : highlightFromUrl === "false"
            ? false
            : props.highlight;
    return (_jsx(SecurityContextProvider, { value: { overwrite, highlight, access }, children: children }));
}
